import { useImpersonation } from "@hooks/useImpersonation";
import { useRestoreSession } from "@hooks/useRestoreSession";
import { useSession } from "@hooks/useSession";
import React from "react";
import { useInitAnalytics } from "@hooks/useInitAnalytics";
import { LoadingPlaceholder } from "../../LoadingPlaceholder";
import { AuthenticatedMemberApp } from "./AuthenticatedMemberApp";
import { MemberAuthRoutes } from "./MemberAuthRoutes";
import { useSkipPhoneVerification } from "./useSkipPhoneVerification";

export const MemberApp: React.FC = () => {
  const restoreSession = useRestoreSession();
  const { personId, accountId } = useSession();
  const impersonation = useImpersonation();

  useSkipPhoneVerification();
  useInitAnalytics(!restoreSession.isLoading, accountId);

  if (restoreSession.isLoading) {
    return <LoadingPlaceholder />;
  }

  // An impersonation token is Account-bound and carries no Person principal, so
  // `personId` alone cannot decide whether anybody is signed in — gating on it
  // would drop every impersonation straight back onto the sign-in screen.
  if (!personId && !impersonation) {
    return <MemberAuthRoutes />;
  }

  return <AuthenticatedMemberApp key={personId ?? accountId} />;
};
